import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-accent/15 bg-surface/40 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxkvik8ui7s">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop742ryb3le">I {totalBonuses} <span className="text-primary" data-id="element-21" data-mp="15pw2z0yk0oxw">Bonus Esclusivi</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-accent/20 bg-background/55 shadow-lg shadow-black/30" data-id="element-22" data-mp="1jgr39ouzlxpv">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-accent/10 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="r083m59xo0ct" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-accent/40 bg-surface/60 text-accent" data-id="element-24" data-mp="2jixqooh9uyz9">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2oitsch2hyebn" />
                </span>
                <div data-id="element-26" data-mp="1qvbnhhbyhwcx">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-primary" data-id="element-27" data-mp="1vsbupvkjl55m">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-foreground" data-id="element-28" data-mp="20qvhfy6ymkz1">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-29" data-mp="25rj3s6k8udmx">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-primary bg-background/70 px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-30" data-mp="3h5ekhjqsqug9">
          <div data-id="element-31" data-mp="1c4kgwfj476hu">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-32" data-mp="1c53pv6qsekjq">Valore di tutti i {totalBonuses} bonus</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-primary decoration-2" data-id="element-33" data-mp="1q3jwyyskad2e">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="ydp7n24pendq">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-35" data-mp="yajg7g8lr9eu">Il tuo prezzo oggi</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-primary" data-id="element-36" data-mp="1757m98m04v4p">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="12er9lqq09dje" /> GRATIS
            </p>
          </div>
        </div>
      </div>
    </section>;
}